<template>
  <div class="booking-menu">
    <ul style="cursor: pointer; padding-left: 0px !important;">
      <li class="padding-li" key="copy" @click="copy">
        <p>Copy</p>
      </li>
      <li class="padding-li" key="edit" @click="edit">
        <p>Edit</p>
      </li>
      <li v-if="booking.state == 'booked'" class="padding-li" key="assign" @click="assign">
        <p>Assign</p>
      </li>
      <li v-if="booking.state == 'accepted'" class="padding-li" key="reassign" @click="reassign">
        <p>Reassign</p>
      </li>
      <li v-if="booking.state == 'accepted'" class="padding-li" key="finish" @click="finish">
        <p>Finish Trip</p>
      </li>
      <li
        v-if="booking.state == 'accepted' || booking.state == 'cancelled'"
        class="padding-li"
        key="recover"
        @click="recoverTrip()"
      >
        <p>Recover Trip</p>
      </li>
      <li
        class="padding-li"
        key="cancel"
        @click="cancelTrip()"
        v-if="booking.state != 'cancelled' && booking.state != 'completed'"
      >
        <p>Cancel Trip</p>
      </li>
      <li class="padding-li" key="call_customer" @click="close()">
        <a :href="'tel:' + formatNumber(booking.customer_number)">
          <p>Call Customer {{formatNumber(booking.customer_number)}}</p>
        </a>
      </li>
      <li v-if="booking.currentTaxi != null" class="padding-li" key="call_driver" @click="close()">
        <a :href="'tel:' + formatNumber(booking.currentTaxi.driver.contact_number)">
          <p>Call Driver {{formatNumber(booking.currentTaxi.driver.contact_number)}}</p>
        </a>
      </li>
      <li v-if="booking.driver != null" class="padding-li" key="call_driver" @click="close()">
        <a :href="'tel:' + formatNumber(booking.driver.contact_number)">
          <p>Call Driver {{formatNumber(booking.driver.contact_number)}}</p>
        </a>
      </li>
      <li
        v-if="booking.currentTaxi == null && booking.preassigned_driver != null"
        class="padding-li"
        key="call-preassigned-driver"
        @click="close()"
      >
        <a :href="'tel:' + formatNumber(booking.preassigned_driver.driver.contact_number)">
          <p>Call Preassigned Driver {{formatNumber(booking.preassigned_driver.driver.contact_number)}}</p>
        </a>
      </li>
      <li
        v-if="booking.state == 'accepted'"
        class="padding-li"
        key="message"
        @click="message(booking.currentTaxi)"
      >
        <p>Message Driver</p>
      </li>
      <li
        v-if="booking.currentTaxi == null && booking.preassigned_driver != null"
        class="padding-li"
        key="message_preassigned_driver"
        @click="messageNumber(booking.preassigned_driver.driver.contact_number)"
      >
        <p>SMS Message Preassigned Driver</p>
      </li>
      <li
        v-if="booking.state == 'accepted'"
        class="padding-li"
        key="message_driver"
        @click="messageNumber(booking.currentTaxi.driver.contact_number)"
      >
        <p>SMS Message Driver</p>
      </li>
    </ul>
    <v-divider></v-divider>
    <v-layout v-if="mode == null && booking.offer_taxis != null" class="confirm-container">
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="cancelOffer()"
          color="red"
          class="text-none"
          dark
        >Cancel Offer</v-btn>
      </v-flex>
    </v-layout>
    <v-layout style="width: 100%;" class="confirm-container" v-if="mode=='finish'">
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="confirmFinish()"
          color="green"
          class="text-none"
          dark
        >Confirm Finish</v-btn>
      </v-flex>
    </v-layout>
    <v-layout style="width: 100%;" class="confirm-container" v-if="mode=='cancel'">
      <v-flex grow>
        <v-btn
          v-if="!loading"
          @click="confirmCancel()"
          color="green"
          class="text-none"
          dark
        >Confirm Cancel</v-btn>
      </v-flex>
    </v-layout>
    <v-layout style="width: 100%;" class="confirm-container" v-if="mode=='recover'">
      <v-flex grow>
        <v-checkbox v-model="manualAssign" label="Hold back"></v-checkbox>
        <v-btn
          v-if="!loading"
          @click="confirmRecover()"
          color="green"
          class="text-none"
          dark
        >Confirm Recover</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog
        :smsMode="smsMode"
        @sent="messageDialog = false"
        :taxi="taxi"
        :number="number"
      />
    </v-dialog>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { replaceStart } from "@/components/util/PhoneNumbers.js";

import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  components: {
    MessageDriverDialog
  },
  name: "BookingMenu",
  props: {
    booking: Object
  },
  data() {
    return {
      mode: null,
      loading: false,
      manualAssign: true,
      messageDialog: false,
      taxi: null,
      smsMode: false,
      number: ""
    };
  },
  mounted: function() {
    // console.log(this.booking);
  },
  methods: {
    message: function(taxi) {
      console.log("Message");
      if (taxi.driver.chat_enabled == true) {
        this.$store.state.driverToMessage = taxi.driver.id;
        this.$store.state.driverToMessageName = taxi.driver.name;
        this.close();
      } else {
        this.taxi = taxi;
        this.messageDialog = true;
      }
    },
    messageNumber: function(number) {
      this.smsMode = true;
      this.number = number;
      this.messageDialog = true;

      this.close();
    },
    formatNumber: function(number) {
      return replaceStart(number);
    },
    close: function() {
      this.mode = null;
      this.$emit("close");
    },
    finish: function() {
      this.mode = "finish";
    },
    assign: function() {
      this.$emit("assign", null);
      this.close();
    },
    reassign: function() {
      this.$emit("reassign", null);
      this.close();
    },
    track: function() {
      this.$emit("track", null);
    },
    copy: function() {
      this.$emit("copy", null);
      this.close();
    },
    edit: function() {
      this.$emit("edit", null);
      this.close();
    },
    reset: function() {
      console.log("Reset");
      this.mode = null;

      this.close();
    },
    recoverTrip: function() {
      this.manualAssign = true;
      this.mode = "recover";
    },
    cancelTrip: function() {
      this.mode = "cancel";
    },
    confirmFinish: function() {
      console.log("Cancel called");

      var url = `${this.$store.state.apiUrl}/booking/finish/${this.booking.id}`;

      var reset = this.reset;
      this.loading = true;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Finished trip");
          } else {
            console.log("Failed to finish booking");

            var error = res.data.error;

            if (error == "no_booking") {
              alert("This booking does not exist");
            } else if (error == "unable_to_set_final_destination") {
              alert(
                "Unable to set final destination for booking - please book manually"
              );
            } else if (error == "cost_too_low") {
              alert(res.data.message);
            } else if (error == "booking_in_wrong_state") {
              alert("Booking is in wrong state");
            } else if (error == "card_error") {
              alert("This booking has a card error");
            } else if (error == "auth_required") {
              alert("This booking requires card authorisation by customer");
            } else {
              alert(res.data.error);
            }
          }
        })
        .catch(function(err) {
          vm.loading = false;
          console.error(err);
        });
    },
    confirmCancel: function() {
      console.log("Cancel called");

      var url = `${this.$store.state.apiUrl}/booking/cancel/${this.booking.id}`;

      var reset = this.reset;
      this.loading = true;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          vm.loading = false;
          if (res.data.error == "no_error") {
            reset();
            console.log("Cancelled trip");
          } else {
            console.log("Failed to cancel booking");
          }
        })
        .catch(function(err) {
          vm.loading = false;
          console.error(err);
        });
    },
    cancelOffer: function() {
      console.log("Recover called");

      var url = `${this.$store.state.apiUrl}/overwatch/cancelOffer?booking_id=${this.booking.id}`;

      this.loading = true;
      var reset = this.reset;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Cancelled offer for trip");
          } else {
            console.log("Failed to cancel offer for booking");
          }
        })
        .catch(function(err) {
          vm.loading = false;
          console.error(err);
        });
    },
    confirmRecover: function() {
      console.log("Recover called");

      var url = `${this.$store.state.apiUrl}/booking/recover/${this.booking.id}?manual_dispatch=${this.manualAssign}`;

      this.loading = true;
      var reset = this.reset;
      var vm = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          vm.loading = false;

          if (res.data.error == "no_error") {
            reset();
            console.log("Recovered trip");
          } else {
            console.log("Failed to recover booking");
          }
        })
        .catch(function(err) {
          vm.loading = false;
          console.error(err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.booking-menu {
  background-color: white;
}

.confirm-container {
  padding: 12px;
}
</style>
